import React from "react";
import { RawHTML } from "react-dom";
import styled, { css } from "styled-components";
import SAMBA_LOGO from "images/bio_logo.png";
import { useTranslation } from "react-i18next";

const ConatinerDiv = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    z-index: 100;
`;
const A4Div2 = styled.div`
    width: 210mm;
    min-height: 297mm;
    padding: 0mm 15mm 15mm 15mm;
    margin: 10px auto;
    border: 0.5px solid #eeeeee;
    box-shadow: rgb(170, 170, 170) 3px 3px 4px 0px;
    position: relative;
`;

const A4Div = (props, _ref) => {
    React.useEffect(() => {
        let cnt1 = 0;
        let cnt2 = 0;
        let cnt3 = 0;
        let cnt4 = 0;

        let tCnt = 0;
        let tImg = 0;
        const pdfContainer = document.getElementById("pdf-preview");
        pdfContainer?.querySelectorAll("h1, h2, h3, h4, figcaption").forEach((e) => {
            if (e.tagName.toUpperCase() === "FIGCAPTION") {
                const figure = e.closest("figure");
                const isTable = figure.classList.contains("table");
                const isImage = figure.classList.contains("image");
                if (isTable) {
                    tCnt++;
                    e.innerText =
                        `Table ${tCnt}. ` +
                        e.innerText.toString().replaceAll(/^Table [\d.]+\. /g, "");
                } else if (isImage) {
                    tImg++;
                    e.innerText =
                        `Figure ${tImg}. ` +
                        e.innerText.toString().replaceAll(/^Figure [\d.]+\. /g, "");
                }
            } else {
                switch (e.tagName.toUpperCase()) {
                    case "H1":
                        cnt1++;
                        e.innerText =
                            `${cnt1}. ` + e.innerText.toString().replaceAll(/^[\d. ]+\./g, "");

                        cnt2 = 0;
                        cnt3 = 0;
                        cnt4 = 0;
                        break;
                    case "H2":
                        cnt2++;
                        e.innerText =
                            `${cnt1}.${cnt2}. ` +
                            e.innerText.toString().replaceAll(/^[\d. ]+\./g, "");

                        cnt3 = 0;
                        cnt4 = 0;
                        break;
                    case "H3":
                        cnt3++;
                        e.innerText =
                            `${cnt1}.${cnt2}.${cnt3}. ` +
                            e.innerText.toString().replaceAll(/^[\d. ]+\./g, "");

                        cnt4 = 0;
                        break;
                    case "H4":
                        cnt4++;
                        e.innerText =
                            `${cnt1}.${cnt2}.${cnt3}.${cnt4}. ` +
                            e.innerText.toString().replaceAll(/^[\d. ]+\./g, "");
                        break;
                    default:
                        break;
                }
            }
        });
    }, [props]);

    return (
        <A4Div2>
            <div
                style={{
                    width: "100%",
                    height: "20mm",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <div style={{ flex: 1, textAlign: "left", height: "10mm" }}>
                    <img src={SAMBA_LOGO} style={{ height: "100%" }} alt={"logo"} />
                </div>
                <div style={{ flex: 1, textAlign: "center" }}>Process Control Strategy</div>
                <div style={{ flex: 1, textAlign: "right" }}></div>
            </div>
            <div
                className="ck-content"
                dangerouslySetInnerHTML={{ __html: props.innerItem.join("") }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    bottom: "5mm",
                    right: "15mm",
                    fontSize: "0.8rem",
                }}
            >
                {props.footerItem}
            </div>
        </A4Div2>
    );
};

const PreviewContainer = (props, _ref) => {
    const [RenderDom, SetRenderDom] = React.useState(null);
    const { t } = useTranslation(["page"]);
    React.useEffect(() => {
        const domroot = document.createElement("div");
        domroot.innerHTML = props.children;
        let cnt = 0;
        const doms = new Array([]);

        domroot.childNodes.forEach((e, i) => {
            if (e.classList.contains("page-break")) {
                cnt++;
            } else {
                if (!doms[cnt]) {
                    doms.push([]);
                }
                doms[cnt].push(e.outerHTML);
            }
        });
        SetRenderDom(doms);

        window.history.pushState(null, '', window.location.href)
        const onPopState = (e) => {
            props?.onClose()
        }
        window.onpopstate = onPopState;
    }, [props]);

    const A4Render = React.useMemo(() => {
        return RenderDom?.map((inner, index) => {
            return (
                <A4Div
                    key={"maindescpreview" + index}
                    
                    innerItem={inner}
                    footerItem={`${index + 1} of ${RenderDom.length}`}
                />
            );
        });
    }, [RenderDom]);
    return (
        <ConatinerDiv position={props.position}>
            <div id="pdf-preview" style={{overflowY: "auto"}}>
                <div
                    className="d-flex justify-between align-center gap-10"
                    style={{ paddingRight: "20px", position: "sticky", top: "30px" }}
                >
                    <span style={{ fontSize: "0.75rem", color: "var(--danger-color)" }}>
                        {t("previewWarn")}
                    </span>
                    <button onClick={props?.onClose} className="bpl-btn danger">
                        X
                    </button>
                </div>
                {A4Render}
            </div>
        </ConatinerDiv>
    );
};

export default PreviewContainer;
